let user = JSON.parse(localStorage.getItem('user'));
export default user;